
export default {
  components: {},
  props: {
    categoryLink: {
      type: String,
      default: "#"
    },
    categoryImage: {
      type: String,
    },
    categoryName: {
      type: String,
      default: 'Category Name'
    },
    catSlug: {
      type: String,
      default: 'forts'
    },

    categoryNos: {
      type: Number,
      default: 0
    }
  }
}

